import React from 'react';
import './Checkbox.scss';

type CheckboxProps = {
  id: string;
  label: string;
  checked: boolean;
  onChange: (value: boolean) => void;
};

export function Checkbox({ id, label, checked, onChange }: CheckboxProps) {
  return (
    <label className="contained-checkbox" htmlFor={id}>
      <input
        id={id}
        className="contained-checkbox-input"
        type="checkbox"
        checked={checked}
        onChange={({ target }) => onChange(target.checked)}
      />
      <span className="contained-checkbox-label">{label}</span>
    </label>
  );
}
